import React, { PureComponent } from "react";
import "./AccountPage.css";
import search from "../../assets/images/search.png";
import ResultComponent from "../ResultComponent/ResultComponent";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { endpointURL } from "../../values";
class AccountPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      certs: [],
      address: "",
      customerName: "",
      searchVal: "",
      dropDownOpen: false,
      dropDownOption: 0,
    };
  }

  Logout = () => {
    Cookies.remove("token");
    Cookies.remove("customer_id");
    Cookies.remove("customer_name");
    Cookies.remove("customer_address");

    this.props.history.push("/");
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      let value = event.target.value;
      this.setState({ searchVal: value }, () => {
        this.searchCerts();
      });
    }
  };

  toggleDropDown = () => {
    let val = this.state.dropDownOpen;
    this.setState({ dropDownOpen: !val });
  };

  chooseDropDown = (val) => {
    this.setState({ dropDownOption: val, dropDownOpen: false });
  };

  updateSearch = (e) => {
    let value = e.target.value;
    this.setState({ searchVal: value });
    if (value == "") {
      let parent = this;
      var getCertData = new Promise(function (resolve, reject) {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + Cookies.get("token");

        axios
          .post(endpointURL + "/get-certs-by-customer-id", {
            // headers: {
            //   Authorization: "JWT " + Cookies.get("token"),
            // },
            // data: {
            customerID: Cookies.get("customer_id"),
            certHubClient: true,
            // },
          })
          .then(function (res) {
            resolve(res);
          })
          .catch(function (error) {
            // console.log(error);
          });
      });
      getCertData.then(function (result) {
        //Result contains cert data
        // console.log(result.data);
        parent.setState({ certs: result.data }, function () {
          // console.log("WE NOW HAVE: " + this.state.certs);
        });
      });
    }
  };

  clearSearch = () => {
    this.updateSearch({ target: { value: "" } });
    document.getElementById("searchBar").value = "";
  };

  searchCerts = () => {
    let parent = this;
    var getCertData = new Promise(function (resolve, reject) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + Cookies.get("token");
      axios
        .post(endpointURL + "/search", {
          // headers: {
          //   Authorization: "JWT " + Cookies.get("token"),
          // },
          // data: {
          customName: parent.state.searchVal,
          customerID: Cookies.get("customer_id"),
          certHubClient: true,
          // },
        })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (error) {
          // console.log(error);
        });
    });
    getCertData.then(function (result) {
      // console.log(result.data);
      parent.setState({ certs: result.data }, function () {
        // console.log("WE NOW HAVE: " + this.state.certs);
      });
    });
  };

  componentDidMount() {
    let parent = this;
    this.setState({
      address: Cookies.get("customer_address"),
      customerName: Cookies.get("customer_name"),
      email: Cookies.get("customer_email"),
    });
    // if (!parent.props.location.state) {
    //   this.props.history.push("/");
    // } else {
    var getCertData = new Promise(function (resolve, reject) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + Cookies.get("token");
      axios
        .post(endpointURL + "/get-certs-by-customer-id", {
          // headers: {
          //   Authorization: "JWT " + Cookies.get("token"),
          // },
          // data: {
          customerID: Cookies.get("customer_id"),
          certHubClient: true,
          // },
        })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (error) {
          // console.log(error);
        });
    });
    getCertData.then(function (result) {
      //Result contains cert data
      // console.log(result.data);
      parent.setState({ certs: result.data }, function () {
        // console.log("WE NOW HAVE: " + this.state.certs);
      });
    });
    // }
  }
  render() {
    let self = this;
    const certResults = this.state.certs.map(function (cert) {
      let finalCert = cert;
      finalCert.address = self.state.address;
      finalCert.customerName = self.state.customerName;
      if (self.state.dropDownOption > 0) {
        let val = self.state.dropDownOption - 1;
        if (finalCert.cert_type == val) {
          return <ResultComponent cert={finalCert} />;
        } else {
          return <> </>;
        }
      } else {
        return <ResultComponent cert={finalCert} />;
      }
    });
    let currentSelectionOption = "All Certs";
    switch (this.state.dropDownOption) {
      case 0:
        currentSelectionOption = "All Certs";
        break;
      case 1:
        currentSelectionOption = "GA1 Certs";
        break;
      case 2:
        currentSelectionOption = "GA1 Lifting Acc.";
        break;
      case 3:
        currentSelectionOption = "GA1 Fall Arrest Certs";
        break;
      case 3:
        currentSelectionOption = "Quarry Brake Report";
        break;
      case 4:
        currentSelectionOption = "Fire Ext. Certs";
        break;
    }

    if (!Cookies.get("token")) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className="account__main">
          <div className="account__util">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                className="account__dropdown"
                onClick={() => {
                  this.toggleDropDown();
                }}
              >
                <span
                  style={{
                    marginRight: "15px",
                    marginLeft: "auto",
                    overflow: "hidden",
                  }}
                >
                  {currentSelectionOption}
                </span>{" "}
                <span style={{ marginRight: "15px", marginLeft: "auto" }}>
                  {this.state.dropDownOpen ? "▲" : "▼"}
                </span>
              </div>
              {this.state.dropDownOpen && (
                <div className="account__dropdown-list">
                  <div
                    className="account__dropdown-item noselect"
                    onClick={() => this.chooseDropDown(0)}
                  >
                    All Certs
                  </div>
                  <div
                    className="account__dropdown-item noselect"
                    onClick={() => this.chooseDropDown(1)}
                  >
                    GA1 Certs
                  </div>
                  <div
                    className="account__dropdown-item noselect"
                    onClick={() => this.chooseDropDown(2)}
                  >
                    GA1 Lifting Acc.
                  </div>
                  <div
                    className="account__dropdown-item noselect"
                    onClick={() => this.chooseDropDown(3)}
                  >
                    GA1 Fall Arrest
                  </div>
                  <div
                    className="account__dropdown-item noselect"
                    onClick={() => this.chooseDropDown(4)}
                  >
                    Quarry Brake Report
                  </div>
                  <div
                    className="account__dropdown-item noselect"
                    onClick={() => this.chooseDropDown(5)}
                  >
                    Fire Ext. Certs
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                marginLeft: "0px",
                marginRight: "auto",
              }}
              id="search-bit"
              className="account__search-section"
            >
              <input
                type="text"
                id="searchBar"
                onKeyPress={this.handleKeyPress}
                className="account__search-bar"
                onChange={(e) => this.updateSearch(e)}
              />
              {this.state.searchVal != "" && (
                <div
                  className="account__end-search"
                  onClick={() => this.clearSearch()}
                >
                  x
                </div>
              )}
              <div
                className="account__search-button"
                onClick={() => this.searchCerts()}
              >
                <img src={search} className="account__search-image" />
              </div>
            </div>
            <div className="account__title" id="account-title">
              <span style={{ fontWeight: "bold" }}>My Account:</span>{" "}
              {this.state.email}
            </div>

            <div className="account__logout" onClick={() => this.Logout()}>
              Logout
            </div>
          </div>
          <div className="account__headers">
            <div
              className="account__header-text"
              style={{ marginLeft: "20px", width: "15%" }}
            >
              Cert Type:
            </div>
            <div style={{ width: "30%" }} className="account__header-text">
              Name:
            </div>
            <div
              style={{ width: "15%" }}
              className="account__header-text"
              id="header-exam"
            >
              Serial/Chassis No:
            </div>
            <div
              style={{ width: "15%" }}
              className="account__header-text"
              id="header-exam"
            >
              Exam Date:
            </div>

            <div
              style={{ width: "15%" }}
              className="account__header-text"
              id="header-renew"
            >
              Renewal Due:
            </div>
            <div
              style={{ width: "15%", marginRight: "20px" }}
              className="account__header-text"
            >
              View/Download
            </div>
          </div>
          <div
            style={{
              height: "150px",
              overflow: "scroll",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {certResults}
            <div style={{ minHeight: "30px" }}></div>
            {/* <div className="account__results"></div> */}
          </div>
        </div>
      );
    }
  }
}

export default AccountPage;
